(() => {
  const selector = "[data-ap-oil-product]";

  function parseVariants(root) {
    try {
      return JSON.parse(root.querySelector("[data-ap-oil-variants]")?.textContent || "[]");
    } catch (error) {
      console.error("Aromatica oil variants could not be parsed.", error);
      return [];
    }
  }

  function selectedOptions(root) {
    return Array.from(root.querySelectorAll("[data-ap-oil-option]:checked")).map(
      (input) => input.value,
    );
  }

  function findVariant(root, variants) {
    const direct = root.querySelector(
      "[data-ap-oil-option]:checked[data-variant-id]",
    );
    if (direct?.dataset.variantId) {
      const match = variants.find(
        (variant) => String(variant.id) === direct.dataset.variantId,
      );
      if (match) return match;
    }

    const options = selectedOptions(root);
    return variants.find(
      (variant) =>
        variant.options.length === options.length &&
        variant.options.every((option, index) => option === options[index]),
    );
  }

  function setGalleryImage(root, source, alt, mediaId) {
    const image = root.querySelector(".ap-oil__main-image");
    if (!image || !source) return;
    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.src = source;
    image.alt = alt || image.alt || "";
    root.querySelectorAll("[data-ap-oil-thumb]").forEach((thumbnail) => {
      thumbnail.setAttribute(
        "aria-pressed",
        mediaId && thumbnail.dataset.mediaId === String(mediaId)
          ? "true"
          : "false",
      );
    });
  }

  function setVariant(root, variant) {
    const idInput = root.querySelector("[data-ap-oil-variant-id]");
    const price = root.querySelector("[data-ap-oil-price]");
    const compare = root.querySelector("[data-ap-oil-compare]");
    const add = root.querySelector("[data-ap-oil-add]");
    const addText = root.querySelector("[data-ap-oil-add-text]");
    const stock = root.querySelector("[data-ap-oil-stock]");
    const stockText = root.querySelector("[data-ap-oil-stock-text]");

    if (idInput) {
      idInput.value = variant?.id || "";
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (!variant) {
      if (add) add.disabled = true;
      if (addText) addText.textContent = root.dataset.unavailableLabel || "Unavailable";
      return;
    }

    if (price) price.textContent = variant.priceCurrency;
    if (compare) {
      const hasCompare =
        Number(variant.compareAtPrice || 0) > Number(variant.price || 0);
      compare.hidden = !hasCompare;
      compare.textContent = hasCompare ? variant.compareAtPriceCurrency : "";
    }
    if (add) add.disabled = !variant.available;
    if (addText) {
      addText.textContent = variant.available
        ? `${root.dataset.addLabel || "Add to bag"} · ${variant.priceFormatted}`
        : root.dataset.soldLabel || "Sold out";
    }
    if (stock && stockText) {
      stock.classList.toggle("ap-oil__stock--sold", !variant.available);
      stockText.textContent = variant.available
        ? stock.dataset.inStock
        : stock.dataset.soldOut;
    }
    if (variant.featuredImage) {
      setGalleryImage(
        root,
        variant.featuredImage,
        variant.featuredImageAlt,
        variant.featuredMediaId,
      );
    }

    if (window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
    }
  }

  function bindQuantity(root) {
    const input = root.querySelector("[data-ap-oil-quantity-input]");
    const minus = root.querySelector("[data-ap-oil-minus]");
    const plus = root.querySelector("[data-ap-oil-plus]");
    if (!input || !minus || !plus) return;

    const normalize = (value) =>
      Math.max(Number(input.min) || 1, Number.parseInt(value, 10) || 1);
    const update = (value, notify = false) => {
      input.value = normalize(value);
      minus.disabled = Number(input.value) <= (Number(input.min) || 1);
      if (notify) input.dispatchEvent(new Event("change", { bubbles: true }));
    };
    minus.addEventListener("click", () => update(Number(input.value) - 1, true));
    plus.addEventListener("click", () => update(Number(input.value) + 1, true));
    input.addEventListener("change", () => update(input.value));
    update(input.value);
  }

  function init(root) {
    if (!root || root.dataset.apOilReady === "true") return;
    root.dataset.apOilReady = "true";
    const variants = parseVariants(root);

    root.querySelectorAll("[data-ap-oil-thumb]").forEach((thumbnail) => {
      thumbnail.addEventListener("click", () =>
        setGalleryImage(
          root,
          thumbnail.dataset.gallerySrc,
          thumbnail.dataset.galleryAlt,
          thumbnail.dataset.mediaId,
        ),
      );
    });

    root.querySelectorAll("[data-ap-oil-option]").forEach((input) => {
      input.addEventListener("change", () =>
        setVariant(root, findVariant(root, variants)),
      );
    });

    bindQuantity(root);
    const initialId = root.querySelector("[data-ap-oil-variant-id]")?.value;
    const initialVariant =
      variants.find((variant) => String(variant.id) === initialId) ||
      findVariant(root, variants);
    setVariant(root, initialVariant);
  }

  function initAll(scope = document) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
